import {
  Box,
  Button,
  Container,
  Field,
  Flex,
  Stack,
  InputGroup,
  Center,
  Text,
} from '@chakra-ui/react';
import { LuLock } from 'react-icons/lu';
import { useState } from 'react';
import ToggleColorMode from '@components/ToggleColorMode';
import Logo from '@components/Logo';
import AuthImagePlaceholder from '@components/AuthImagePlaceholder';
import ErrorLabel from '@components/ErrorLabel';
import PasswordInput from '@components/PasswordInput';
import PasswordValidator from '@components/PasswordValidator';

import useForm from './useForm'

const NewPassword = () => {
  const [password, setPassword] = useState('');

  const { onSubmit, loading, errors } = useForm();

  return (
    <Flex height="100vh" flex="1">
      <Box position="absolute" top="4" left="4">
        <ToggleColorMode />
      </Box>
      <Center flex="1.5" py={{ base: '24', md: '32' }}>
        <Container maxW="md">
          <Stack gap="6">
            <Flex justifyContent="center" alignItems="center" flexDirection="column" gap={2}>
              <Logo />
              <Text color="fg.muted" textAlign="center">
                Insira abaixo sua nova senha.
              </Text>
            </Flex>

            <form onSubmit={onSubmit}>
              <Stack gap="5">
                <Field.Root invalid={!!errors?.password}>
                  <Field.Label>Senha</Field.Label>
                  <InputGroup startElement={<LuLock />} width="full" gap={0}>
                    <PasswordInput
                      name="password"
                      placeholder="••••••••"
                      minLength={8}
                      variant="subtle"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </InputGroup>
                  {errors?.password?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>

                {password && (
                  <PasswordValidator password={password} />
                )}
                <Field.Root invalid={!!errors?.confirmPassword}>
                  <Field.Label>Confirmar senha</Field.Label>
                  <InputGroup startElement={<LuLock />} width="full" gap={0}>
                    <PasswordInput name="confirmPassword" placeholder="••••••••" minLength={8} variant="subtle" required />
                  </InputGroup>
                  {errors?.confirmPassword?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>

                {errors?.general && (
                  <Flex direction="column" my={4}>
                    {errors.general.map((error, index) => (
                      <ErrorLabel key={index} text={error} />
                    ))}
                  </Flex>
                )}
                <Button
                  colorPalette="argos"
                  loading={loading}
                  type="submit"
                >
                  Redefinir
                </Button>
              </Stack>
            </form>

          </Stack>
        </Container>
      </Center>
      <Box flex="1" hideBelow="lg">
        <AuthImagePlaceholder />
      </Box>
    </Flex>
  );
};

export default NewPassword;
